module.exports = __webpack_public_path__ + "img/coffee_ios_802.png";